import { render, staticRenderFns } from "./HelpdeskBlockedEmails.vue?vue&type=template&id=06a67b89"
import script from "./HelpdeskBlockedEmails.vue?vue&type=script&lang=js"
export * from "./HelpdeskBlockedEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports